import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
// import DateRanger from "../../../components-react/DateRanger";
import PiChartData from "./PiChartData";
import {
  fetchGymsAttendanceDetailedData,
  fetchTargetAchievedDetailsData,
} from "../../../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import LightTable from "../../../components-bootstrap/LightTable";
import {
  convertTime,
  convertUnixTimestampToDate,
} from "../../../common-data/Converts";

const AttendanceHistoryDetails = ({
  clickedCard,
  gymsData,
  tdFilters,
  selectedDatesQueryParam,
  decryptedText,
  loading,
}) => {
  const dispatch = useDispatch();
  const { gymAttendanceDetLoading, gymTargetDetails, gymAttendanceDetails } =
    useSelector((state) => state.api);
  const iniDetails = {
    allCheckinDetails: [],
    shiftCheckinDetails: [],
    allDetails: [],
    checkinDetailModal: false,
    shiftCheckinModal: false,
    trainerName: "",
  };
  const [trainersDatas, setTrainerDatas] = useState(iniDetails);
  const iniCardValues = {
    cardValueModal: false,
    cardValue: "",
  };
  const [clickedCardValue, setClickedCardValue] = useState(iniCardValues);
  const [sendableQPs, setSendableQPs] = useState("");

  const onCloseModal = () => {
    setClickedCardValue(iniCardValues);
  };

  const closeCheckinDetailModal = (name) => {
    if (name === "checkin_details") {
      setTrainerDatas((prevs) => ({
        ...prevs,
        shiftCheckinModal: false,
        shiftCheckinDetails: [],
      }));
    } else {
      setTrainerDatas((prevs) => ({
        ...prevs,
        checkinDetailModal: false,
        allCheckinDetails: [],
        trainerName: "",
      }));
    }
  };

  useEffect(() => {
    if (clickedCardValue?.cardValue && selectedDatesQueryParam) {
      const monthQP = tdFilters.selectedMonth?.value
        ? `&month=${tdFilters.selectedMonth.value}`
        : "";
      const yearQP = tdFilters.selectedYear?.value
        ? `&year=${tdFilters.selectedYear.value}`
        : "";
      const gymQP = clickedCardValue?.cardValue
        ? `&gym_id=${clickedCardValue.cardValue}`
        : tdFilters.selectedGym?.value
        ? `&gym_id=${tdFilters.selectedGym.value}`
        : "";
      const trainerQP = tdFilters.selectedTrainer?.value
        ? `&trainer_id=${tdFilters.selectedTrainer.value}`
        : "";
      const sendableQUeryParam = `${monthQP}${yearQP}${gymQP}${trainerQP}${selectedDatesQueryParam}`;
      setSendableQPs(sendableQUeryParam);
    }
  }, [tdFilters, clickedCardValue, selectedDatesQueryParam]);

  useEffect(() => {
    if (clickedCardValue.cardValue) {
      const monthQP = tdFilters.selectedMonth?.value
        ? `&month=${tdFilters.selectedMonth.value}`
        : "";
      const yearQP = tdFilters.selectedYear?.value
        ? `&year=${tdFilters.selectedYear.value}`
        : "";
      const gymQP = clickedCardValue?.cardValue
        ? `&gym_id=${clickedCardValue.cardValue}`
        : tdFilters.selectedGym?.value
        ? `&gym_id=${tdFilters.selectedGym.value}`
        : "";
      const trainerQP = tdFilters.selectedTrainer?.value
        ? `&trainer_id=${tdFilters.selectedTrainer.value}`
        : "";
      const sendableQUeryParam = `${monthQP}${yearQP}${gymQP}${trainerQP}${selectedDatesQueryParam}`;

      if (clickedCard === "monthly_target") {
        dispatch(
          fetchTargetAchievedDetailsData({
            queryParameters: sendableQUeryParam,
            token: decryptedText?.token,
          })
        );
      } else if (clickedCard === "attendance") {
        dispatch(
          fetchGymsAttendanceDetailedData({
            queryParameters: sendableQUeryParam,
            token: decryptedText?.token,
          })
        );
      }
    } else {
      setTrainerDatas(iniDetails);
    }
  }, [clickedCardValue, tdFilters, selectedDatesQueryParam]);

  // useEffect(() => {
  //   if (clickedCardValue.cardValue && sendableQPs) {
  //     if (clickedCard === "monthly_target") {
  //       dispatch(
  //         fetchTargetAchievedDetailsData({
  //           queryParameters: sendableQPs,
  //           token: decryptedText?.token,
  //         })
  //       );
  //     } else if (clickedCard === "attendance") {
  //       dispatch(
  //         fetchGymsAttendanceDetailedData({
  //           queryParameters: sendableQPs,
  //           token: decryptedText?.token,
  //         })
  //       );
  //     }
  //   }
  // }, [sendableQPs, clickedCardValue]);

  useEffect(() => {
    if (
      clickedCard === "monthly_target" &&
      gymTargetDetails?.status &&
      gymTargetDetails?.data
    ) {
      setTrainerDatas({
        ...trainersDatas,
        allDetails: gymTargetDetails.data,
      });
    } else if (
      clickedCard === "attendance" &&
      gymAttendanceDetails?.status &&
      gymAttendanceDetails?.data
    ) {
      setTrainerDatas({
        ...trainersDatas,
        allDetails: gymAttendanceDetails.data,
      });
    } else {
      setTrainerDatas(iniDetails);
    }
  }, [clickedCard, gymTargetDetails, gymAttendanceDetails]);

  const tbColumns = [
    {
      dataField: "trainer_name",
      text: "Trainer Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="name hoverBlue"
            style={{
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => {
              setTrainerDatas((prevs) => ({
                ...prevs,
                checkinDetailModal: true,
                allCheckinDetails: row?.shift_details,
                trainerName: row?.trainer_name,
                cardType: "shift_details",
              }));
            }}
          >
            {row?.trainer_name || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "mobile",
      text: "Trainer Mobile",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info">{row?.mobile || "-"}</p>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150">{row?.gym_name || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "is_absent_btwn_dates",
      text: "Is Absent",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              color: row?.is_absent_btwn_dates ? "#CD0909" : "#3D9A0B",
            }}
          >
            {row?.is_absent_btwn_dates ? "Yes" : "No"}
          </p>
        </div>
      ),
    },
  ];

  const tbColumnsChDetail = [
    {
      dataField: "shift_name",
      text: "Shift Time",
      formatter: (cell, row) => (
        <div
          className="emeberDetailsRowContainer column"
          style={{
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={() => {
            setTrainerDatas((prevs) => ({
              ...prevs,
              shiftCheckinModal: true,
              shiftCheckinDetails: row?.checkin_details,
              cardType: "checkin_details",
            }));
          }}
        >
          <p className="name">{row?.shift_name || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "start_time",
      text: "Start Time",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info">
            {row?.start_time ? convertTime(row.start_time) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "end_timee",
      text: "End Time",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info">
            {row?.end_time ? convertTime(row.end_time) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info">
            {row?.date_added ? convertUnixTimestampToDate(row.date_added) : "-"}
          </p>
        </div>
      ),
    },
  ];

  const ChDetailTbCols = [
    {
      dataField: "date",
      text: "Date",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info">{row?.date || "-"}</p>
        </div>
      ),
    },
    {
      dataField: "shift_type",
      text: "Shift Time",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="name">{row?.shift_type || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "time2",
      text: "Time",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info">{row?.time2 ? convertTime(row.time2) : "-"}</p>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickedCardValue.cardValueModal}
        onRequestClose={onCloseModal}
        contentLabel="Trainer Details"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer cloud-bg-k borderRadiusTen">
          <ModalHeadAndClose title="Trainer Details" onClose={onCloseModal} />

          {gymAttendanceDetLoading ? (
            <ReactVortoxSpinner />
          ) : (
            <div>
              <LightTable
                data={trainersDatas.allDetails || []}
                columns={tbColumns}
              />
            </div>
          )}
        </div>
      </Modal>

      <Modal
        isOpen={trainersDatas.checkinDetailModal}
        onRequestClose={closeCheckinDetailModal}
        contentLabel="Trainer Checkin Details"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer cloud-bg-k borderRadiusTen">
          <ModalHeadAndClose
            title={`${
              trainersDatas.trainerName ? trainersDatas.trainerName : "Trainer"
            } Shift Details`}
            onClose={closeCheckinDetailModal}
          />

          <div>
            <LightTable
              data={trainersDatas.allCheckinDetails || []}
              columns={tbColumnsChDetail}
            />
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={trainersDatas.shiftCheckinModal}
        onRequestClose={() => closeCheckinDetailModal("checkin_details")}
        contentLabel="Trainer Checkin Details"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer maxWidth60vw cloud-bg-k borderRadiusTen">
          <ModalHeadAndClose
            title={`${
              trainersDatas.trainerName ? trainersDatas.trainerName : "Trainer"
            } Checkin Details`}
            onClose={() => closeCheckinDetailModal("checkin_details")}
          />

          <div>
            <LightTable
              data={trainersDatas.shiftCheckinDetails || []}
              columns={ChDetailTbCols}
            />
          </div>
        </div>
      </Modal>

      <div className="mainContainer detailsPageContainer">
        <div className="innerContainer">
          <div className="globalGymANdDatesFilterContainer ptFlow">
            <div className="ptHeading">
              <h1 className="heading">
                {clickedCard === "attendance"
                  ? "Trainers Attendance History"
                  : "Gym Target Achievment"}
              </h1>
            </div>
          </div>

          {loading ? (
            <ReactVortoxSpinner />
          ) : (
            <PiChartData
              clickedCard={clickedCard}
              gymsData={gymsData}
              setClickedCardValue={setClickedCardValue}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AttendanceHistoryDetails;
